/**
 * @desc getSiteEfficiency
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.SiteEfficiencyMasterResponseDto>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/logistics/getSiteEfficiency`, {
      method: "POST",

      ...options,
    }),
  );
}
